import * as cn from "classnames";
import * as React from "react";
import "./NotificationComponent.css";
import { connect } from "react-redux";
import { AppState, closeNotificationAction } from "@store";
import { Dispatch } from "redux";

export interface NotificationComponentProps {
    isOpen: boolean;
    message: string;
    isWarning?: boolean;
    closeNotification: () => void;
}

export class NotificationComponent extends React.Component<NotificationComponentProps> {
    componentDidUpdate() {
        if (this.props.isOpen) {
            setTimeout(() => {
                this.props.closeNotification();
            }, 3000);
        }
    }

    render() {
        const { isOpen, message, isWarning } = this.props;

        return (
            <div className={cn("notification-popup", isOpen ? "popup-opened" : "", isWarning ? "warning" : "")}>
                <h4>Notification</h4>
                <p>{message}</p>
            </div>
        );
    }
}

export const Notification = connect(
    (state: AppState) => {
        const { isOpen, message, isWarning } = state.pagesState.notification;

        return {
            isOpen,
            message,
            isWarning
        };
    },
    (dispatch: Dispatch) => ({
        closeNotification: () => {
            dispatch(closeNotificationAction({}));
        }
    })
)(NotificationComponent);
